"use client";

import { c as _c } from "react/compiler-runtime";
import { useIntl } from "react-intl";
import Consent from "forms/fields/Consents/Consent";
import type { FormControlType } from "types/formType";
import type { IFormInputs } from "types/uiSchema";
import { Fieldset } from "ui/Fieldset";
import { FormField } from "uiShadcn/form";
interface ConsentsProps {
  control: FormControlType;
  uiData: IFormInputs;
}
export default function Consents(t0) {
  const $ = _c(12);
  const {
    uiData,
    control
  } = t0;
  const {
    formatMessage
  } = useIntl();
  const dictionary = uiData["x-dictionary"];
  if (!dictionary || dictionary?.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== formatMessage) {
    t1 = formatMessage({
      id: "consents"
    });
    $[0] = formatMessage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== control || $[3] !== dictionary || $[4] !== formatMessage) {
    let t3;
    if ($[6] !== control || $[7] !== formatMessage) {
      t3 = (t4, i) => {
        const {
          key,
          value
        } = t4;
        return <FormField name={key} key={key} control={control} render={t5 => {
          const {
            field
          } = t5;
          return <Consent name={key} value={Boolean(field.value)} onCheckedChange={field.onChange} consent={value} dataTestId={`consent-${key}`} readMoreInfo={`${formatMessage({
            id: "consent"
          })} ${i + 1}`} />;
        }} />;
      };
      $[6] = control;
      $[7] = formatMessage;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = dictionary.map(t3);
    $[2] = control;
    $[3] = dictionary;
    $[4] = formatMessage;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <Fieldset title={t1} variant="grey">{t2}</Fieldset>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}